import React, { useEffect, useRef, useState } from "react";
import {
  addCollege,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import HttpClientXml from "../../../utils/HttpClientXml";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const CollegeUniversityStep2 = ({ data, setData, setCurrentStep, currentStep }) => {

  const initialValues = {
    bannerHeading: data?.bannerHeading,
    bannerText: data?.bannerText,
    aboutText: data?.aboutText
  }

  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  console.log("KIU32", data?.bannerHeading);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();

    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success("Data saved successfully");
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          bannerHeading: formData?.bannerHeading,
          bannerText: formData?.bannerText,
          aboutText: formData?.aboutText
        })
        setCurrentStep(currentStep + 1)
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  useEffect(() => {
    console.log("KIU69", data);

    setFormData(initialValues)
  }, [data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Banner Heading<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData?.bannerHeading}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    bannerHeading: e?.target?.value,
                  }));
                }}
                placeholder="Enter Heading Text"
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Banner Text<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData?.bannerText}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    bannerText: e?.target?.value,
                  }));
                }}
                placeholder="Short Description"
              //currentStep
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="longDescription">
                About <span className="text-danger">*</span>
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.aboutText}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    aboutText: value,
                  }));
                }}
                placeholder="Enter Long Description"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>

          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 1 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityStep2;
